import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ICheckboxFieldSpecs } from "libraries/module/formbuilder/fields/interfaces/field-specs";

@Component({
    selector: 'checkbox-field',
    template: `
        <form-field [formGroup]="fieldConfig.formGroup"
                    [options]="fieldConfig"
                    [attr.class]="fieldConfig.className">
            <div class="checkbox-wrapper e2e-restriction" [class.small-height]="isSmallHeight" [class.checkbox-label-ellipsis]="addLabelEllipsis">
                <mat-checkbox [formControlName]="fieldConfig.formControlName"
                              [disableRipple]="true"
                              [disabled]="fieldConfig.disabled"
                              (change)="onChange.emit($event.checked)">
                    {{fieldConfig.checkboxLabel}}
                </mat-checkbox>
            </div>
        </form-field>
    `,
    styleUrls: [
        '../../../../../styles/angular-material/checkbox.scss',
    ],
    styles: [`
        .checkbox-wrapper:not(.small-height) {
            padding-top: 0.4rem;
            padding-bottom: 0.4rem;
        }

        ::ng-deep .checkbox-label-ellipsis > mat-checkbox .mat-checkbox-layout {
            max-width: 100%;
        }

        ::ng-deep .checkbox-label-ellipsis > mat-checkbox .mat-checkbox-layout span {
            overflow: hidden;
            text-overflow: ellipsis;
        }
    `]
})
export class CheckboxFieldComponent {

    /** Required. */
    @Input()
    public fieldConfig: ICheckboxFieldSpecs;
    @Input()
    public isSmallHeight: boolean;
    @Input()
    public addLabelEllipsis: boolean = false;

    /** Emits when checkbox is checked/unchecked. true : checked, false : unchecked. */
    @Output()
    public readonly onChange: EventEmitter<boolean> = new EventEmitter<boolean>();

}
